<template>
    <div>
        <img v-if="isSuccess" :src="imageSrc" alt="icon" :title="name" style=""/>
        <span v-else :title="name">{{ name }}</span>
    </div>
</template>

<script>

export default {
    props: {
        photo_link: {
            type: String,
        },
        eventBus: {
            type: Object,
        },
        columnIndex: {
            Type: Number
        },
        columnIdentify: {
            Type: String
        },
        name: {
            Type: String
        },
        config: {
            Type: Object
        },
        parentIndex: {
            Type: Number
        },
    },
    data() {
        return {
            imageSrc: null,
            isSuccess: true,
        };
    },
    mounted() {
        if (this.config.imageSrc !== null) {
            this.imageSrc = this.config.imageSrc;
        } else {
            this.imageSrc = `dist/${this.config.imageName}.png`;
        }

        let image = new Image();
        image.addEventListener('error', this.onImageLoad);
        image.src = this.imageSrc;
    },
    methods: {
        onImageLoad: function() {
            this.isSuccess = false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// IconHeaderComponent.vue?48630c7a